import { useState } from "react";
import CloseIcon from "./../../../assets/icons/close.svg?react";
import {
  Typography,
  Button,
  getLocalStorage,
  setLocalStorage,
} from "djuno-design";

const MarketApiBanner = () => {
  const docsUrl = import.meta.env.VITE_DOCS_URL || "";
  const localStorageName = "market-api-banner";
  const showWeb3Banner = getLocalStorage<boolean>(localStorageName, true);
  const [show, setShow] = useState<boolean>(showWeb3Banner);
  const closeBanner = () => {
    setLocalStorage<boolean>(localStorageName, false);
    setShow(false);
  };

  if (!show) return null;
  return (
    <div className="relative w-full bg-gray-50 dark:bg-dark-3 border border-slate-300 dark:border-dark-2 p-6 rounded-lg flex flex-col">
      <CloseIcon
        onClick={closeBanner}
        className="absolute right-3 top-3 text-slate-500 dark:text-slate-300 w-5 hover:scale-110 duration-300 cursor-pointer"
      />
      <div className="flex items-center w-full justify-between">
        <Typography.Text className="text-sm">
          Get started with Market API
        </Typography.Text>
      </div>
      <div className="flex items-center gap-2 mt-5 flex-wrap">
        <a
          href={
            docsUrl +
            "/en/articles/10143315-market-insight-api-reference#h_e84e7bf548"
          }
          target="_blank"
          rel="noreferrer"
        >
          <Button>Coin</Button>
        </a>
        <a
          href={
            docsUrl +
            "/en/articles/10143315-market-insight-api-reference#h_9aad35a01b"
          }
          target="_blank"
          rel="noreferrer"
        >
          <Button>Blockchains</Button>
        </a>
        <a
          href={
            docsUrl +
            "/en/articles/10143315-market-insight-api-reference#h_6c75269a02"
          }
          target="_blank"
          rel="noreferrer"
        >
          <Button>Exchanges</Button>
        </a>
        <a
          href={
            docsUrl +
            "/en/articles/10143315-market-insight-api-reference#h_1b169f665d"
          }
          target="_blank"
          rel="noreferrer"
        >
          <Button>Markets</Button>
        </a>
        <a
          href={
            docsUrl +
            "/en/articles/10143315-market-insight-api-reference#h_37ea9e36cc"
          }
          target="_blank"
          rel="noreferrer"
        >
          <Button>Reference currencies</Button>
        </a>
        <a
          href={
            docsUrl +
            "/en/articles/10143315-market-insight-api-reference#h_6707409b24"
          }
          target="_blank"
          rel="noreferrer"
        >
          <Button>Coin Stats</Button>
        </a>
        <a
          href={
            docsUrl +
            "/en/articles/10143315-market-insight-api-reference#h_25875c3c09"
          }
          target="_blank"
          rel="noreferrer"
        >
          <Button>Search</Button>
        </a>
        <a
          href={
            docsUrl +
            "/en/articles/10143315-market-insight-api-reference#h_e2c24729da"
          }
          target="_blank"
          rel="noreferrer"
        >
          <Button>Bulk coins</Button>
        </a>
        <a
          href={
            docsUrl +
            "/en/articles/10143315-market-insight-api-reference#h_3a26b3a7a2"
          }
          target="_blank"
          rel="noreferrer"
        >
          <Button>Real-time</Button>
        </a>
      </div>
    </div>
  );
};

export default MarketApiBanner;
